import MuiDialog, { DialogProps as Props } from '@material-ui/core/Dialog'
import MuiDialogActions, {
  DialogActionsProps as MuiDialogActionsProps
} from '@material-ui/core/DialogActions'
import MuiDialogContent, {
  DialogContentProps as MuiDialogContentProps
} from '@material-ui/core/DialogContent'
import MuiDialogContentText, {
  DialogContentTextProps as MuiDialogContentTextProps
} from '@material-ui/core/DialogContentText'
import MuiDialogTitle, {
  DialogTitleProps as MuiDialogTitleProps
} from '@material-ui/core/DialogTitle'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from '../../components/base/Color'
import Box from '../base/Box'
import IconButton from '../button/IconButton'

export type DialogActionsProps = MuiDialogActionsProps
export type DialogContentProps = MuiDialogContentProps
export type DialogContentTextProps = MuiDialogContentTextProps
export type DialogTitleProps = MuiDialogTitleProps

export type DialogProps = {
  hideCloseIcon?: boolean
  title?: string
  content?: React.ReactNode
  action?: React.ReactNode
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: Color.base.modalOverlay
    },
    paper: {
      padding: theme.spacing(5),
      position: 'relative'
    },
    title: {
      padding: 0,
      marginBottom: theme.spacing(2)
    },
    content: {
      padding: 0,
      marginBottom: theme.spacing(9)
    },
    action: {
      justifyContent: 'center',
      gridGap: theme.spacing(1),
      padding: 0
    },
    closeIcon: {
      position: 'absolute',
      top: 0,
      right: 0
    },
    titleText: {
      ...theme.typography.h4
    }
  })
)

export const DialogActions = MuiDialogActions
export const DialogContent = MuiDialogContent
export const DialogContentText = MuiDialogContentText
export const DialogTitle = MuiDialogTitle

const Dialog: React.FC<DialogProps> = (props) => {
  const {
    hideCloseIcon,
    title,
    content,
    action,
    onClose = (): void => {},
    children,
    ...rest
  } = props
  const classes = useStyles()
  return (
    <MuiDialog
      {...rest}
      onClose={onClose}
      classes={{ root: classes.root, paper: classes.paper }}
    >
      {title && (
        <DialogTitle classes={{ root: classes.title }}>
          {!hideCloseIcon && (
            <IconButton
              onClick={(e: any): void => {
                onClose(e, 'backdropClick')
              }}
              className={classes.closeIcon}
              iconName="CloseIcon"
              iconSize="small"
            />
          )}
          <Box className={classes.titleText}>{title}</Box>
        </DialogTitle>
      )}
      {children}
      {content && (
        <DialogContent classes={{ root: classes.content }}>
          {content}
        </DialogContent>
      )}
      {action && (
        <DialogActions classes={{ root: classes.action }}>
          {action}
        </DialogActions>
      )}
    </MuiDialog>
  )
}

export default Dialog
